import { useFormContext, useController } from 'react-hook-form'
import {
  Checkbox,
  FormControlLabel,
  FormControlLabelProps,
} from '@mui/material'

export type CheckBoxFieldProps = Partial<FormControlLabelProps> & {
  name: string
  label: string
  multiple?: boolean
  value?: string
}

const CheckboxField = ({
  name,
  value,
  multiple = false,
  ...props
}: CheckBoxFieldProps) => {
  const { control, setValue } = useFormContext()
  const { field } = useController({ control, name })

  const isChecked = multiple ? field.value.includes(value) : field.value

  const handleChange = () => {
    if (!multiple) return setValue(name, !field.value)

    return setValue(
      name,
      isChecked
        ? field.value.filter((v: string) => v !== value)
        : [...field.value, value],
      { shouldDirty: true }
    )
  }

  return (
    <FormControlLabel
      {...props}
      onChange={handleChange}
      checked={isChecked}
      control={<Checkbox name={name} color="primary" />}
    />
  )
}

export default CheckboxField
